<markant-guided-tour
  #guidedTourElement
  [target]="guidedTourTarget"
  [nextButton]="nextButton"
  [backButton]="backButton"
  [enableClickThrough]="enableClickThrough"
  (changed)="onChanged()"
></markant-guided-tour>

@if (
  guidedTourSteps[currentStep - 1] &&
  guidedTourSteps[currentStep - 1].nextOnOverlayClick
) {
  <div class="click-overlay" (click)="onNext()"></div>
}
